// extracted by mini-css-extract-plugin
module.exports = {"poiSearchAutoComplete":"components-PoiSearchAutoComplete-PoiSearchAutoComplete__poiSearchAutoComplete--26Y3t"};